// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.formkpi span{
    color: var(--third-color);
    font-size: var(--font-size-small);
}









.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: #fff !important;
    padding: 20px;
    border-radius: 8px;
    
    max-width: 90% !important;
    text-align: center;
}

.form-group {
    margin-bottom: 15px;
    text-align: left;
}

label {
    font-weight: bold;
}

/* input, select {
    
    padding: 8px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
} */

.formula {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 10px;
    
}


.operator, .value-input {
   border: 1px solid #ccc;
    border-radius: 4px;
    width:  80px !important;
    height: 30px !important;
    background: var(--white-color);
    color: var(--txt-color);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding:unset !important;
    text-align: center !important;
}

.modal-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.create-button {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
}

.cancel-button {
    background-color: #ccc;
    color: #333;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/components/reportes-components/Kpi/KpiFormModal.css"],"names":[],"mappings":";;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;;;;;;;;;AAUA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;;IAElB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;GAMG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;;AAEpB;;;AAGA;GACG,sBAAsB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;IAC9B,uBAAuB;IACvB,wCAAwC;IACxC,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":["\r\n\r\n.formkpi span{\r\n    color: var(--third-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n    background: #fff !important;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    \r\n    max-width: 90% !important;\r\n    text-align: center;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 15px;\r\n    text-align: left;\r\n}\r\n\r\nlabel {\r\n    font-weight: bold;\r\n}\r\n\r\n/* input, select {\r\n    \r\n    padding: 8px;\r\n    margin-top: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n} */\r\n\r\n.formula {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    margin-top: 10px;\r\n    \r\n}\r\n\r\n\r\n.operator, .value-input {\r\n   border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    width:  80px !important;\r\n    height: 30px !important;\r\n    background: var(--white-color);\r\n    color: var(--txt-color);\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding:unset !important;\r\n    text-align: center !important;\r\n}\r\n\r\n.modal-buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 20px;\r\n}\r\n\r\n.create-button {\r\n    background-color: #007bff;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.cancel-button {\r\n    background-color: #ccc;\r\n    color: #333;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
